import { HTMLAttributes } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

export interface TabProps extends HTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  value: string | number;
}

export const Tab = ({ active, value, ...rest }: TabProps) => (
  <button
    id={`tab-${value}`}
    aria-controls={`tabpanel-${value}`}
    aria-selected={active}
    type="button"
    role="tab"
    tw="flex cursor-pointer pb-2 transition duration-fast focus:outline-none not-last:mr-3"
    css={[[active && tw`border-secondary! text-secondary border-b-1`], [!active && tw`text-gray-70`]]}
    style={{ marginBottom: '-1px' }}
    {...rest}
  />
);

export const Tabs = tw.div`flex border-b-1 border-gray-30`;

export interface TabPanelProps extends HTMLAttributes<HTMLDivElement> {
  value: string | number;
  activeValue: string | number;
}

export const TabPanel = ({ value, activeValue, children, ...props }: TabPanelProps) => (
  <div
    role="tabpanel"
    id={`tabpanel-${value}`}
    aria-labelledby={`tab-${value}`}
    hidden={value !== activeValue}
    {...props}
  >
    {value === activeValue && children}
  </div>
);
